import styles from './index.module.scss';
import { memo, useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'react-flexbox-grid';

import GameRow from '../game-row';
import FairnessModal from '@modules/fairness-modal';

// import { animated, useTrail } from "react-spring";
import { AppState } from '@redux/stores/store';

import { filterGames } from '@hooks/useFetchCoinflipGames';
import { ICoinflipGame } from '@api/types/Coinflip';
import GameHistory from '@components/game-history';
import GameFee from '@components/game-fee';
import GameFairness from '@components/game-fairness';
import useGamesActivePlayers from '@hooks/useGamesActivePlayers';

export function CoinflipGameList(): JSX.Element {
    // eslint-disable-next-line no-unused-vars
    const [_forceUpdate, setForceUpdate] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setForceUpdate(new Date().getTime());
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    });

    const games = useSelector((state: AppState) => state.coinflipData);
    const { statistics } = useSelector((state: AppState) => state.userData);
    const [seeMore, setSeeMore] = useState(false);
    const [fairnessModalOpen, setFairnessModalOpen] = useState<boolean>(false);
    const [fairnessModalGame, setFairnessModalGame] =
        useState<ICoinflipGame | null>(null);
    const { coinflipActivePlayers } = useGamesActivePlayers({
        fetch: { coinflip: true },
    });

    const { oldGames, recentGames } = filterGames(Object.values(games));

    /*
    So esentially what this code does is convert the current coinflip games into a object
    Now with the object we can have the index of the original coinflip games array
    Now we get the object entries of the array which itself will return an array with the index of the game
    in the original array and the game data itself, after that we filter the games with the condition needed 
    in this case will be "Active games", after that we just ensure that in the re-rendering process there is no
    repeated games
  */

    // const oldGamesTrail = useTrail(oldGames.length, {
    //   from: { y: 600, opacity: 0 },
    //   y: oldGames.length > 0 ? 0 : 500,
    //   opacity: oldGames.length > 0 ? 1 : 0,
    // });

    // const newGamesTrail = useTrail(recentGames.length, {
    //   from: { y: 100, opacity: 0 },
    //   y: recentGames.length > 0 ? 0 : 500,
    //   opacity: recentGames.length > 0 ? 1 : 0,
    // });

    const handleFairnessModal = useCallback(
        (state: boolean, game?: ICoinflipGame | null) => {
            setFairnessModalOpen(state);
            setFairnessModalGame(game || null);
        },
        [fairnessModalOpen],
    );

    return (
        <section className={styles.coinflip}>
            <Row className={styles.heading}>
                <Col lg={6} className={styles.data}>
                    <span className={styles.text}>
                        {recentGames.length > 0
                            ? 'Active Games'
                            : 'Recent Games'}
                    </span>
                    <span className={styles.count}>
                        {coinflipActivePlayers} player
                        {coinflipActivePlayers === 1 ? '' : 's'} in-game
                    </span>
                </Col>
                <Col lg={6} className={styles.buttonContainer}>
                    <GameHistory
                        onClick={() => setSeeMore((prevState) => !prevState)}
                        stats={statistics.coinflip}
                    />
                    <GameFee percentage={2} />
                    <GameFairness />
                </Col>
            </Row>

            {recentGames &&
                recentGames.map((gameId, index) => (
                    // <animated.div
                    //   style={newGamesTrail[index] as any}
                    //   key={`${gameId}-recent-anim`}
                    //   className={styles.animation_container}
                    // >
                    <GameRow
                        key={`${gameId}-gamerow`}
                        gameId={gameId}
                        first={index === 0}
                        last={index === recentGames.length - 1}
                        single={recentGames.length === 1}
                    />
                    // </animated.div>
                ))}

            {recentGames.length > 0 && (
                <Row className={styles.heading} style={{ marginTop: '25px' }}>
                    <Col lg={6}>
                        <span className={styles.text}>Recent Games</span>
                    </Col>
                </Row>
            )}

            {oldGames &&
                (seeMore ? [...oldGames] : [...oldGames.slice(0, 5)]).map(
                    (gameId, index) => (
                        // <animated.div
                        //   style={oldGamesTrail[index] as any}
                        //   key={`${gameId}-old-anim`}
                        // >
                        <GameRow
                            key={`${gameId}-gamerow`}
                            gameId={gameId}
                            first={index === 0}
                            last={
                                !seeMore
                                    ? index === 4
                                    : index === oldGames.length - 1
                            }
                            single={!seeMore && oldGames.length == 1}
                            openFairnessModal={(game: ICoinflipGame) => {
                                handleFairnessModal(true, game);
                            }}
                        />
                        // </animated.div>
                    ),
                )}

            {/* todo: add fair modal */}
            <FairnessModal
                open={fairnessModalOpen}
                game={fairnessModalGame}
                close={() => handleFairnessModal(false)}
            />
        </section>
    );
}

export default memo(CoinflipGameList);
